<template>
  <ButtonSocial :type="'telegram'" @click="loginWithTelegram"/>
</template>

<script setup>
import ButtonSocial from '@shared/UI/Buttons/ButtonSocial/ButtonSocial';
import { backendUrl } from '@shared/constants/urls/appUrls';

const loginWithTelegram = () => {
  window.location.href = `${backendUrl}/api/telegram/login/`;
};
</script>
